import { Radio } from 'antd';

import { CustomImage } from '@src/components';

import { bankCodeIcon, cardTypeIcon } from '@src/utils/utils';

import '@src/styles/autoUploadInstruction/creditCards.scss';

const CreditCards = ({ cardItem }) => {
  const bankIcon = bankCodeIcon(cardItem?.bankCode);
  const cardIcon = cardTypeIcon(cardItem?.cardType);

  return (
    <Radio
      id={`ticketRestaurant-balanceUpload-balanceInformation-orderType-${cardItem?.cardToken}`}
      value={cardItem?.cardToken}
      key={cardItem?.id}
    >
      <div className="autoUploadInstruction-credit-card-item">
        <CustomImage className="bank-card-logo" src={bankIcon} />
        <div className="card-number">{cardItem?.maskedCardNumber}</div>
        <div className="card-info">
          <CustomImage className="card-type-logo" src={cardIcon} />
        </div>
      </div>
    </Radio>
  );
};

export default CreditCards;
